// Providers are defined by Firebase Auth => https://cloud.google.com/identity-platform/docs/how-to#sign-in
export enum AuthProvider {
  Unspecified = 'unspecified',
  EmailPassword = 'password',
  Microsoft = 'microsoft.com',
}
